import { Flex, Text, Title } from "@mantine/core";
import { IconSearch, IconBookmark, IconUsers } from "@tabler/icons-react";
import { circleIcon } from "./PricingStyles";

export default function HowItWorksSection() {
  return (
    <Flex direction="column" align="center" py={60} px="xl" maw={1200} mx="auto">
      <Title order={2} mb="xs" ta="center">
        How It Works
      </Title>
      <Text c="slate.6" ta="center">
        No subscriptions. No hidden fees. Pay only when you connect.
      </Text>

      <Flex
        gap={60}
        justify="center"
        mt="xl"
        direction={{ base: "column", sm: "row" }}
        align={{ base: "center", sm: "flex-start" }}
        w="100%"
      >
        <Flex direction="column" align="center" ta="center" flex={1}>
          <IconSearch
            size={24}
            color="var(--mantine-color-primary-6)"
            style={circleIcon("var(--mantine-color-primary-0)")}
          />
          <Text fw={600} mb="xs">
            1. Browse for Free
          </Text>
          <Text size="xs" c="slate.6">
            Search and explore anonymized company profiles. View capabilities, certifications, and verification status
            at no cost.
          </Text>
        </Flex>

        <Flex direction="column" align="center" ta="center" flex={1}>
          <IconBookmark
            size={24}
            color="var(--mantine-color-primary-6)"
            style={circleIcon("var(--mantine-color-primary-0)")}
          />
          <Text fw={600} mb="xs">
            2. Express Interest
          </Text>
          <Text size="xs" c="slate.6">
            Found a potential partner? Express your interest. If they're interested too, you'll get a match
            notification.
          </Text>
        </Flex>

        <Flex direction="column" align="center" ta="center" flex={1}>
          <IconUsers
            size={24}
            color="var(--mantine-color-primary-6)"
            style={circleIcon("var(--mantine-color-primary-0)")}
          />
          <Text fw={600} mb="xs">
            3. Pay to Collaborate
          </Text>
          <Text size="xs" c="slate.6">
            When both parties agree, pay once to activate a secure workspace with NDA protection and collaboration
            tools.
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
